import { Helmet } from 'react-helmet-async';
// sections
import { BusinessHoursListView } from 'src/sections/business-hours';

// ----------------------------------------------------------------------

export default function BusinessHoursListPage() {
  return (
    <>
      <Helmet>
        <title>Horários de Funcionamento | Dashboard</title>
      </Helmet>

      <BusinessHoursListView />
    </>
  );
}
